'use strict';
const angular = require('angular');
const {isNumber} = angular;

export const FirebaseConnectionServiceImport = [
  '$log',
  '$q',
  '$timeout',
  'FirebaseUtil',
  FirebaseConnectionService];

function FirebaseConnectionService(
  $log,
  $q,
  $timeout,
  FirebaseUtil,
) {
  let _online = true;

  Object.defineProperty(this, 'online', {enumerable: true, get: onlineGetter});

  this.init = initWatcher;

  function onlineGetter() {
    return _online;
  }

  function initWatcher(delay) {
    if (!isNumber(delay)) delay = 1000; // default: wait one minute, then start checking for online status

    var connectedRef = FirebaseUtil.firebaseRef('.info/connected');
    var timeout;
    var lastStatus = null;
    var updateDeferred = $q.defer();

    $timeout(function () {
      timeout = $timeout(__onTimeout, 2500);

      connectedRef.on('value', __onUpdate, __restartWatcher);

      return $q.any([timeout, updateDeferred.promise]).then(__cleanup);
    }, delay);

    function __onUpdate(ss) {
      $log.info('FirebaseConnectionService is now ' + (ss.val() ? 'online' : 'offline'));
      if (timeout) {
        __onInitialUpdate(ss);
      } else {
        __onPostStartupUpdate(ss)
      }
    }

    function __onInitialUpdate(ss) {
      var newStatus = ss.val();

      if (newStatus) {
        _online = newStatus;
        updateDeferred.resolve();
      } else {
        lastStatus = newStatus;
      }
    }

    function __onPostStartupUpdate(ss) {
      _online = ss.val();
    }

    function __onTimeout() {
      _online = lastStatus !== null ? lastStatus : false; // assume you are offline at this point
    }

    function __cleanup() {
      $timeout.cancel(timeout);
      timeout = null;
    }

    function __restartWatcher() {
      $log.warn('FirebaseConnectionService lost its watcher and is restarting it shortly');
      $timeout(function () {
        connectedRef.on('value', __onUpdate, __restartWatcher);
      }, 200); // wait 200 ms, then try to connect again
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/FirebaseConnectionService.js